import { Component } from '@angular/core';

@Component({
  selector: 'app-products-list-skeleton',
  templateUrl: './products-list-skeleton.component.html',
  styleUrls: ['./products-list-skeleton.component.scss']
})
export class ProductsListSkeletonComponent {}
